<template>
  <div class="container">
    <div class="row row-device">
      <div class="col">
        <div class="panel panel-bordered">
          <div class="row">
            <div class="col-lg-1"></div>
            <div class="col-lg-10">
              <div class="title-heading faq-heading">
                <h2 class="h1 mb-0">{{$static('faq.title','FAQ')}}</h2>
              </div>

              <div class="custom-accordion accordion" id="faq_accordion">
                <div class="panel panel-accordion">
                  <div class="panel-title">
                    <a data-toggle="collapse" aria-expanded="true" href="#panel1" class="label-name">
                      {{$static('faq.q1', 'Як отримати токен вашого бота в телеграм?')}}
                    </a>
                  </div>
                  <div id="panel1" class="panel-collapse collapse in" data-parent="#faq_accordion">
                    <div class="panel-body">
                      <div class="text">
                        <p class="with-pre" v-html="$static('faq.a1', 'Для цього Вам необхідно у рядку пошуку Telegram ввести <b>@BotFather</b>, далі ми потрапляємо до творця ботів і вводимо команду <span>/newbot</span> ')"></p>
                        <p class="with-pre" v-html="$static('faq.a12', 'Див.скрін:')"></p>
                        <img src="/images/faq/faq1.png" class="img-responsive">

                        <p class="with-pre" v-html="$static('faq.a11', 'Далі вводимо назву нашого бота')"></p>
                        <p class="with-pre" v-html="$static('faq.a12', 'Див.скрін:')"></p>
                        <img src="/images/faq/faq2.png" class="img-responsive">
                        <p class="with-pre" v-html="$static('faq.a111', 'Після цього нам потрібно дати URL нашого бота, обов\'язково в кінці назви URL має бути напис <b>_bot _Bot _BOT</b> ')"></p>
                        <p class="with-pre" v-html="$static('faq.a12', 'Див.скрін:')"></p>
                        <img src="/images/faq/faq3.png" class="img-responsive">
                        <p class="with-pre" v-html="$static('faq.a13', 'на даному етапі ми успішно створили нашого бота і отримали заповітний ТОКЕН, його необхідно скопіювати та вставити в адмінку розділу налаштування магазину/налаштування Telegram')"></p>
                        <p class="with-pre" v-html="$static('faq.a12', 'Див.скрін:')"></p>
                        <img src="/images/faq/faq4.png" class="img-responsive">
                        <p class="with-pre" v-html="$static('faq.a14', 'Тиснемо кнопку Зберегти')"></p>
                        <h4 v-html="$static('faq.a15', 'Також нам необхідно прив\'язати доменне ім\'я вашого магазину до боту телеграм, зараз подивимось, як це зробити')"></h4>
                        <p class="with-pre" v-html="$static('faq.a16', 'Тиснемо в <b>BotFather</b> команду <span>/mybots</span>, бачимо бачимо список наших ботів')"></p>
                        <img src="/images/faq/faq5.png" class="img-responsive">
                        <p class="with-pre" v-html="$static('faq.a17', 'Натискаємо в потрібного, далі в меню бота тиснемо <b>Bot Settings</b>')"></p>
                        <img src="/images/faq/faq6.png" class="img-responsive">
                        <p class="with-pre" v-html="$static('faq.a18', 'Після цього тиснемо кнопку <b>Domain</b>')"></p>
                        <img src="/images/faq/faq7.png" class="img-responsive">
                        <p class="with-pre" v-html="$static('faq.a19', 'Після цього тиснемо кнопку <b>Set Domain</b>')"></p>
                        <img src="/images/faq/faq8.png" class="img-responsive">
                        <p class="with-pre" v-html="$static('faq.a20', 'Потім переходимо в Адмін Панель, натискаємо <b>web версія</b>')"></p>
                        <img src="/images/faq/faq9.png" class="img-responsive">
                        <p class="with-pre" v-html="$static('faq.a21', 'Копіюємо URL Вашого магазину')"></p>
                        <p class="with-pre" v-html="$static('faq.a22', 'Вставляємо Ваш URL у боті')"></p>
                        <img src="/images/faq/faq10.png" class="img-responsive">
                        <h4 v-html="$static('faq.a23', 'Вітаємо, тепер ви можете скористатися нашим сервісом UX Web Bot!')"></h4>
                      </div>
                    </div>
                  </div>
                </div>
<!--                <div class="panel panel-accordion">-->
<!--                  <div class="panel-title">-->
<!--                    <a data-toggle="collapse"  aria-expanded="false" href="#panel2" class="label-name collapsed">-->
<!--                      {{$static('faq.q2', 'Якими можливостями володіє сервіс крім продажів в Telegram?')}}-->
<!--                    </a>-->
<!--                  </div>-->
<!--                  <div id="panel2" class="panel-collapse collapse" data-parent="#faq_accordion">-->
<!--                    <div class="panel-body">-->
<!--                      {{$static('faq.a2', 'Lorem ipsum dolor, sit amet consectetur adipisicing, elit. Темпоре, перспіціатіс ад. Soluta sint velit mollitia distinctio, aperiam nihil, culpa nemo dolores consequatur minima dignissimos, atque enim provident placeat nulla, molestias.')}}-->
<!--                    </div>-->
<!--                  </div>-->
<!--                </div>-->
<!--                <div class="panel panel-accordion">-->
<!--                  <div class="panel-title">-->
<!--                    <a data-toggle="collapse"  aria-expanded="false" href="#panel3" class="label-name collapsed">-->
<!--                      {{$static('faq.q3', 'Який тариф підключається при створенні телеграм-магазину?')}}-->
<!--                    </a>-->
<!--                  </div>-->
<!--                  <div id="panel3" class="panel-collapse collapse" data-parent="#faq_accordion">-->
<!--                    <div class="panel-body">-->
<!--                      {{$static('faq.a3', 'Lorem ipsum dolor, sit amet consectetur adipisicing, elit. Темпоре, перспіціатіс ад. Soluta sint velit mollitia distinctio, aperiam nihil, culpa nemo dolores consequatur minima dignissimos, atque enim provident placeat nulla, molestias.')}}-->
<!--                    </div>-->
<!--                  </div>-->
<!--                </div>-->
<!--                <div class="panel panel-accordion">-->
<!--                  <div class="panel-title">-->
<!--                    <a data-toggle="collapse"  aria-expanded="false" href="#panel4" class="label-name collapsed">-->
<!--                      {{$static('faq.q4', 'Що станеться, коли термін дії демо-плану закінчиться?')}}-->
<!--                    </a>-->
<!--                  </div>-->
<!--                  <div id="panel4" class="panel-collapse collapse" data-parent="#faq_accordion">-->
<!--                    <div class="panel-body">-->
<!--                      {{$static('faq.a4', 'Lorem ipsum dolor, sit amet consectetur adipisicing, elit. Темпоре, перспіціатіс ад. Soluta sint velit mollitia distinctio, aperiam nihil, culpa nemo dolores consequatur minima dignissimos, atque enim provident placeat nulla, molestias.')}}-->
<!--                    </div>-->
<!--                  </div>-->
<!--                </div>-->
<!--                <div class="panel panel-accordion">-->
<!--                  <div class="panel-title">-->
<!--                    <a data-toggle="collapse"  aria-expanded="false" href="#panel5" class="label-name collapsed">-->
<!--                      {{$static('faq.q5', 'Чи можна змінити тарифний план після створення телеграм-магазину?')}}-->
<!--                    </a>-->
<!--                  </div>-->
<!--                  <div id="panel5" class="panel-collapse collapse" data-parent="#faq_accordion">-->
<!--                    <div class="panel-body">-->
<!--                      {{$static('faq.a5', 'Lorem ipsum dolor, sit amet consectetur adipisicing, elit. Темпоре, перспіціатіс ад. Soluta sint velit mollitia distinctio, aperiam nihil, culpa nemo dolores consequatur minima dignissimos, atque enim provident placeat nulla, molestias.')}}-->
<!--                    </div>-->
<!--                  </div>-->
<!--                </div>-->
              </div>

              <div class="support-form">
                <div class="title-heading text-center d-flex align-items-center justify-content-center mb-0">
                  <div class="">
                    <h2 class="h3 ">{{ $static('faq.cbt', 'Зворотний звя\'зок') }}</h2>
                    <a href="https://t.me/UXWebSupportBOT" class="support-link">
                      <span>@UXWebSupportBOT</span>
                    </a>
                  </div>
                </div>
              </div>
            </div>
            <div class="col-lg-1"></div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "AdminSupport"
}
</script>

<style scoped>

</style>